// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__djK1h","col":"styles_col__1a903"};